var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"changePasswordForm\" novalidate>\n<change-password event=\"event\" model-details=\"modelDetails\" on-confirm=\"ok\" on-error=\"cancel\"></change-password>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" style=\"margin-top: -50px;\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</form>";
var id1="changePassword.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/templates/changePassword.html
// module id = 2521
// module chunks = 1